'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { installSessionUrlPersistence, runSessionUrlSync } from '@/lib/pwaSession';

/**
 * Restaure la session depuis ?token= / ?session= et garde le jeton dans l’URL
 * sur toutes les pages tant que l’utilisateur n’est pas en PWA installée.
 */
export default function SessionFromUrlBootstrap() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    installSessionUrlPersistence();
  }, []);

  useEffect(() => {
    runSessionUrlSync();
  }, [pathname, searchParams]);

  return null;
}
